import * as React from 'react';
import { lang } from '@umu/ukit-lang';
import { Modal } from '@umu/umu-design';

export const PCModal = ({
    onOk,
    onCancel,
    children,
    title,
    okText = lang('确认'),
    cancelText = lang('取消'),
    className,
}: {
    onOk: VoidFunction;
    onCancel: VoidFunction;
    children: JSX.Element;
    title: string;
    okText?: string;
    cancelText?: string;
    className?: string;
}) => {
    return (
        <Modal
            closable
            centered
            visible
            maskClosable={false}
            onOk={onOk}
            onCancel={onCancel}
            title={title}
            okText={okText}
            cancelText={cancelText}
            wrapClassName={className}
        >
            {children}
        </Modal>
    );
};
